import castArray from "lodash/castArray";
import uniqBy from "lodash/uniqBy";

import { type SearchMultiSelectItem } from "./types";

export function normalizeSelectedItems<Value extends SearchMultiSelectItem>(
  selectedValues: Value | Value[] | null | undefined,
) {
  if (selectedValues == null) return [];

  return castArray(selectedValues);
}

export function hasExactItemMatch<Value extends SearchMultiSelectItem>(
  items: Value[],
  inputValue: string,
) {
  const normalizedInput = inputValue.toLowerCase();

  return items.some(
    (item) =>
      item.id.toLowerCase() === normalizedInput ||
      item.searchValue.toLowerCase() === normalizedInput ||
      item.label.toLowerCase() === normalizedInput,
  );
}

export function hasExactSelectedMatch<Value extends SearchMultiSelectItem>(
  selectedItems: Value[],
  inputValue: string,
) {
  const normalizedInput = inputValue.toLowerCase();

  return selectedItems.some(
    (item) => item.id.toLowerCase() === normalizedInput,
  );
}

export function canCreateOption(
  creatable: boolean,
  inputValue: string,
  exactItemMatch: boolean,
  exactSelectedMatch: boolean,
) {
  return (
    creatable && inputValue.length > 0 && !exactItemMatch && !exactSelectedMatch
  );
}

export function makeCreateOption<Value extends SearchMultiSelectItem>(
  inputValue: string,
) {
  return {
    id: inputValue,
    searchValue: inputValue,
    label: inputValue,
  } as Value;
}

export function mergeItemsWithSelected<Value extends SearchMultiSelectItem>(
  availableItems: Value[],
  selectedItems: Value[],
) {
  return uniqBy([...availableItems, ...selectedItems], "id");
}
